export default {
    listen: function (time = (60 * 60 * 12), onLeave, onActive) {
        this.time = time;
        if (onActive) this.onActive = onActive;
        if (onLeave)  this.onLeave  = onLeave;

        localStorage.setItem('last-activity', this.getTime());
        this.listeners();
        this.startInterval();
    },
    getTime() {
        return Math.round(Date.now() / 1000);
    },
    listeners() {
        ['load', 'click', 'keypress', 'touchstart', 'mousedown', 'scroll']
            .map(action => window.addEventListener(action, e => this.onActivity(e), true));
    },
    startInterval() {
        this.interval = setInterval(() => {
            if (this.getTime() - localStorage.getItem('last-activity') >= this.time && this.onLeave && typeof this.onLeave == 'function') {
                this.onLeave();
                clearInterval(this.interval);
            }
        }, 30000);
    },
    onActivity(e) {
        localStorage.setItem('last-activity', this.getTime());

        if (this.onActive && typeof this.onActive == 'function')
            this.onActive(e);
    }
}


// WEBPACK FOOTER //
// ./src/helpers/inactivity/index.js